import React, { useEffect, useState } from "react";
import { Container, ContentContainer, ReturnContainer } from "./styled";
import { RelatedPosts } from "../../components";
import { Loader } from "../../../components";
import * as contentful from "contentful";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

const Post = (props) => {
  const [articlesBySlug, setArticlesBySlug] = useState([]);
  const location = useLocation();
  let slug = location.pathname.replace("/blog/article/", "");
  let postId = typeof props.postDetails === "string" ? props.postDetails : slug;

  useEffect(() => {
    const client = contentful.createClient({
      space: "ynl21amwlp74",
      environment: "master", // defaults to 'master' if not set
      accessToken: "iLYptGCMCwY_7gJ_ZhltQfhu8fhsGS_LwlSpPK-lIhU",
    });
    if (props.postDetails !== "string" && slug.includes(" ")) {
      client
        .getEntries({
          content_type: "blogPost",
          "fields.title": slug,
        })
        .then((response) => {
          if (response.items.length > 0) {
            // Handle the retrieved entry
            const entry = response.items[0];
            const rawRichTextField = entry.fields.postContent;
            setArticlesBySlug(entry);
            return documentToHtmlString(rawRichTextField);
          } else {
            console.log("Entry not found");
          }
        })
        .catch((error) => {
          // Handle any errors
          console.error(error);
        });
    } else {
      client
        .getEntry(postId)
        .then((entry) => {
          const rawRichTextField = entry.fields.postContent;
          setArticlesBySlug(entry);
          return documentToHtmlString(rawRichTextField);
        })
        .then((renderedHtml) => {
          document.getElementById("rich-text-body").innerHTML = renderedHtml;
        })
        .catch((error) => console.log(error));
    }
  }, []);

  const renderPortada = () => {
    if (
      articlesBySlug.fields.media &&
      articlesBySlug.fields.media.length > 0 &&
      articlesBySlug.fields.media[0].fields.title === "portada"
    ) {
      return (
        <img
          src={articlesBySlug.fields.media[0].fields.file.url}
          alt="Foto de portada"
        />
      );
    } else {
      return (
        <img
          src="../../assets/article-default-portada.jpeg"
          alt="Foto de portada"
        />
      );
    }
  };
  const renderVideo = () => {
    if (
      articlesBySlug.fields.media &&
      articlesBySlug.fields.media.length >= 1
    ) {
      if (
        articlesBySlug.fields.media[0].fields.title === "video" ||
        articlesBySlug.fields.media[0].fields.title === "Video"
      ) {
        return (
          <video autoPlay muted playsInline="" loop="" controls>
            <source
              src={articlesBySlug.fields.media[0].fields.file.url}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        );
      } else if (articlesBySlug.fields.media[1].fields.title === "video") {
        return (
          <video autoPlay muted playsInline="" loop="" controls>
            <source
              src={articlesBySlug.fields.media[1].fields.file.url}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        );
      }
    } else {
      return;
    }
  };

  const SoftwareApplicationStructuredData = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: articlesBySlug.fields?.title,
    image:
      "https://deportacticoapp.vercel.app/assets/article-default-portada.jpeg",
    datePublished: "2015-02-05T08:00:00+08:00",
    dateModified: "2015-02-05T09:20:00+08:00",
    author: [
      {
        "@type": "Person",
        name: "Mr Average Man",
        url: "https://deportacticoapp.vercel.app",
      },
    ],
  };

  return (
    <>
      <Container>
        {articlesBySlug.length <= 0 ? (
          <Loader />
        ) : (
          <>
            <ContentContainer>
              <h1>{articlesBySlug.fields?.title}</h1>
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify(SoftwareApplicationStructuredData),
                }}
              />
              <p className="publishDate">{articlesBySlug.fields.publishDate}</p>
              {articlesBySlug.fields.author ? (
                <p>Escrito por {articlesBySlug.fields.author}</p>
              ) : (
                <p>Autor anonimo</p>
              )}
              {articlesBySlug.fields ? renderPortada() : null}
              {articlesBySlug && (
                <div
                  dangerouslySetInnerHTML={{
                    __html: documentToHtmlString(
                      articlesBySlug.fields.postContent
                    ),
                  }}
                ></div>
              )}
              {renderVideo()}
              {articlesBySlug?.fields?.media?.length > 1 ? (
                <div className="galery-container">
                  {articlesBySlug?.fields?.media?.slice(1).map((image, i) => (
                    <div>
                      <p>{image.fields.title}</p>
                      <img
                        src={image.fields.file.url}
                        alt="Foto de contenido"
                      />
                    </div>
                  ))}
                </div>
              ) : null}
              <RelatedPosts
                tag={articlesBySlug.fields.postTags}
                title={articlesBySlug.fields.title}
              />
            </ContentContainer>
          </>
        )}
      </Container>
      <ReturnContainer>
        <Link to="/blog">Volver al blog</Link>
      </ReturnContainer>
    </>
  );
};
export default Post;

const query = `
{
  blogPostCollection {
    items {
      sys {
        id
      }
      title
      description
      postContent{
        json
      }
      publishDate
      author
      postTags
      enableComments
      comments
      mediaCollection {
        items {
          url
          title
        }
      }
    }
  }
}
`;
